export default __webpack_public_path__ + "static/media/bubble_nova_background_xl1.66db0366.jpg";